import Image from 'next/image';

import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';
import useGetChainInfo from '@/hooks/useGetChainInfo';

import { Trigger } from '../../domain';
import { GEARBOX_MODE_LABELS } from '../../types';
import { AddressChip } from './components/AddressChip';

interface Props {
  trigger: Trigger;
}

export function GearboxTriggerFullDetails({ trigger }: Props) {
  const { getChainIconUrl, getChainName } = useGetChainInfo();

  const rawMode = trigger.context?.gearboxMode ?? trigger.context?.mode;
  const chainId = trigger.context?.chain_id ?? trigger.context?.chainId ?? 1;
  const assetAddress = trigger.context?.asset_address ?? trigger.context?.tokenAddress ?? '';
  const chainIconUrl = getChainIconUrl(chainId);
  const chainName = getChainName(chainId);
  const modeLabel = rawMode ? (GEARBOX_MODE_LABELS[rawMode] ?? rawMode) : 'position';

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow
        label="Executed when"
        value={
          <div className="tw:flex tw:flex-row tw:items-center tw:flex-wrap tw:gap-2">
            <Text variant="body-sm" color="muted" as="span">
              User has a
            </Text>
            <Badge size="sm">{modeLabel}</Badge>
            <Text variant="body-sm" color="muted" as="span">
              on
            </Text>
            <Badge size="sm">Gearbox</Badge>
          </div>
        }
      />
      <KeyValueRow label="Mode" value={rawMode ? <Badge size="sm">{modeLabel}</Badge> : '-'} />
      <KeyValueRow
        label="Asset Address"
        value={assetAddress ? <AddressChip address={assetAddress} chainId={chainId} /> : '-'}
      />
      <KeyValueRow
        label="Network"
        value={
          <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
            {chainIconUrl && <Image src={chainIconUrl} alt={chainName} width={20} height={20} />}
            <span>{chainName}</span>
          </div>
        }
      />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
